import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DatePipe } from "@angular/common";
import memo from "memo-decorator";
let SaShortDatePipe = class SaShortDatePipe extends DatePipe {
    transform(value, args) {
        if (!value) {
            return "";
        }
        return super.transform(value, "yyyy/MM/dd");
    }
};
__decorate([
    memo()
], SaShortDatePipe.prototype, "transform", null);
SaShortDatePipe = __decorate([
    Pipe({
        standalone: false,
        name: "saShortDate"
    })
], SaShortDatePipe);
export { SaShortDatePipe };
